import type { FC } from "react";

import style from "./styles/Form.module.scss";

export interface FormInputHelpProps {
  children: React.ReactNode;
}

const FormInputHelp: FC<FormInputHelpProps> = (props) => {
  return <span className={style.input_help}>{props.children}</span>;
};

export { FormInputHelp };
